import { IconButton, IconLibrary } from '@act/storybook';
import {
  Card,
  CardContent,
  Dialog,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { ReactNode } from 'react';
import { TrackingProvider } from 'react-components/tracking';

interface MemberStatusChangeRequestDialogLayoutProps {
  children: ReactNode;
  onClose: () => void;
  open: boolean;
}

/**
 * Provides the shared full-screen shell for the member status request form.
 *
 * @param props - Dialog visibility, close handler, and form content
 * @returns Member status request dialog layout
 */
export function MemberStatusChangeRequestDialogLayout({
  children,
  onClose,
  open,
}: MemberStatusChangeRequestDialogLayoutProps) {
  return (
    <TrackingProvider contextName="member-status-change-request-dialog">
      <Dialog
        className="member-status-change-request-dialog"
        open={open}
        onClose={onClose}
        fullScreen
        hideBackdrop
      >
        <DialogTitle className="member-status-change-request-dialog-title">
          <IconButton onClick={onClose} trackingName="back-button">
            <IconLibrary iconName="ArrowLeft" size={24} />
          </IconButton>
          Member Status Change Request
        </DialogTitle>

        <DialogContent className="member-status-change-request-dialog-content">
          <Card className="member-status-change-request-dialog-card">
            <CardContent className="member-status-change-request-dialog-card-content">
              {children}
            </CardContent>
          </Card>
        </DialogContent>
      </Dialog>
    </TrackingProvider>
  );
}
